import { Progress } from "@aircall/ds";
import { CSSProperties } from "react";
import { SpeakerAvatar } from "@/components/SpeakerAvatar/SpeakerAvatar";
import { SPEAKER_VARIANT_COLOR } from "@/constants/style.constants";
import {
  RatioBarProps,
  TalkRatioListItemProps,
} from "./TalkRatioListItem.decl";

// The DS Progress indicator defaults to `bg-primary`; colour it from the
// outside via a CSS variable holding the speaker's DS palette colour.
function RatioBar({ ratio, color }: RatioBarProps) {
  return (
    <div className="flex w-full items-center gap-1">
      <Progress
        value={ratio}
        style={{ "--talk-ratio-bar": color } as CSSProperties}
        className="flex-1 [&_[data-slot=progress-indicator]]:bg-[var(--talk-ratio-bar)] [&_[data-slot=progress-track]]:h-[12px] [&_[data-slot=progress-track]]:rounded"
      />
      <span className="w-8 shrink-0 text-right text-tiny font-medium text-muted-foreground tabular-nums">{`${ratio}%`}</span>
    </div>
  );
}

export function TalkRatioListItem({
  ratio,
  channel,
  speakers,
}: TalkRatioListItemProps) {
  const variant = speakers.get(channel)?.variant ?? "green";

  return (
    <div className="flex items-center gap-1">
      <SpeakerAvatar channel={channel} />
      <RatioBar color={SPEAKER_VARIANT_COLOR[variant]} ratio={ratio} />
    </div>
  );
}
